




















































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";
import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "poster/stadiums";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "海报", dataIndex: "poster_name" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "图片", scopedSlots: { customRender: "picurl" } }
  ];

  mounted() {
    this.loadData();
  }
}
